const state = {
    VALID_WITHOUT_PWD: 0,
    VALID: 1,
    INVALID: 9,
    NAME_VALID: "有効",
    NAME_INVALID: "無効",
}
const getText = (code) => {
    switch (+code) {
        case state.VALID:
            return state.NAME_VALID
        case state.VALID_WITHOUT_PWD:
        case state.INVALID:
            return state.NAME_INVALID
        default:
            return ""
    }
}
export default {
    ...state,
    getText
};
